import { REPORTS_ENDPOINT } from "../../constants";
export const reportSummaryQuery = (data) => ({
    url: `${REPORTS_ENDPOINT}/${data.ui_id}/summary`,
    params: data,
});
//# sourceMappingURL=queries.js.map